import { get } from '../lib/apiClient';

/** GET /member-badges/me — the caller's active badges (with definitions) */
export const listMyBadges = () => get('/member-badges/me');

/** GET /member-badges/catalog — all badge definitions */
export const listCatalog = () => get('/member-badges/catalog');
